(function(){
  var PACKS={
    4:{max:4, ogPrice:null, salePrice:75.00, savePct:0},
    8:{max:8, ogPrice:150.00, salePrice:112.00, savePct:25}
  };
  var packSize=4;
  var selected=[];

  var sizeTabs=document.querySelectorAll('.size-tab');
  var packLabel=document.getElementById('packLabel');
  var priceOg=document.getElementById('priceOg');
  var priceSale=document.getElementById('priceSale');
  var priceSave=document.getElementById('priceSave');
  var progressFill=document.getElementById('progressFill');
  var progressCount=document.getElementById('progressCount');
  var progressMax=document.getElementById('progressMax');
  var sbSlots=document.getElementById('sbSlots');
  var sbCta=document.getElementById('sbCta');
  var sbClear=document.getElementById('sbClear');
  var mobileBar=document.getElementById('mobileBar');
  var mobileSlots=document.getElementById('mobileSlots');
  var mobileCount=document.getElementById('mobileCount');
  var mobileSub=document.getElementById('mobileSub');
  var mobileCta=document.getElementById('mobileCta');
  var allCards=document.querySelectorAll('.prod[data-id]');

  if(!sbCta) return;

  sizeTabs.forEach(function(tab){
    tab.addEventListener('click',function(){
      sizeTabs.forEach(function(t){t.classList.remove('active')});
      tab.classList.add('active');
      packSize=parseInt(tab.getAttribute('data-size'));
      if(selected.length>packSize) selected=selected.slice(0,packSize);
      render();
    });
  });

  function clearNode(n){while(n.firstChild)n.removeChild(n.firstChild)}

  function buildSlots(container, size, slotClass, plusClass){
    clearNode(container);
    for(var i=0;i<size;i++){
      var slot=document.createElement('div');
      slot.className=slotClass;
      var item=selected[i];
      if(item){
        slot.classList.add('filled');
        var img=document.createElement('img');
        img.src=item.img;img.alt=item.name;
        slot.appendChild(img);
      } else {
        var plus=document.createElement('span');
        plus.className=plusClass;
        plus.textContent='+';
        slot.appendChild(plus);
      }
      container.appendChild(slot);
    }
  }

  function render(){
    var pack=PACKS[packSize];
    var max=pack.max;
    var n=selected.length;

    if(packLabel) packLabel.textContent='Mix & Match '+max+' Jars';
    if(priceOg){priceOg.textContent=pack.ogPrice?'$'+pack.ogPrice.toFixed(2):'';priceOg.style.display=pack.ogPrice?'':'none'}
    if(priceSale) priceSale.textContent='$'+pack.salePrice.toFixed(2);
    if(priceSave){priceSave.textContent=pack.savePct?'Save '+pack.savePct+'%':'';priceSave.style.display=pack.savePct?'':'none'}
    if(progressMax) progressMax.textContent=max;
    if(progressCount) progressCount.textContent=n;
    if(progressFill) progressFill.style.width=(n/max*100)+'%';

    if(sbSlots) buildSlots(sbSlots, max, 'sb-slot', 'sb-slot-plus');
    if(mobileSlots) buildSlots(mobileSlots, Math.min(max,4), 'mobile-bar-slot', 'mobile-bar-slot-num');

    allCards.forEach(function(card){
      var id=card.getAttribute('data-id');
      var count=selected.filter(function(s){return s.id===id}).length;
      var qtyEl=card.querySelector('.prod-qty');
      if(count>0){card.classList.add('selected');if(qtyEl)qtyEl.textContent=count}
      else{card.classList.remove('selected')}
      card.classList.toggle('full',n>=max&&count===0);
    });

    if(sbClear) sbClear.classList.toggle('vis',n>0);
    if(n<max){
      sbCta.className='sb-cta disabled';
      sbCta.textContent=n===0?'Select Jars to Continue':'Add '+(max-n)+' More';
    } else {
      sbCta.className='sb-cta ready';
      sbCta.textContent='Add to Cart \u2014 $'+pack.salePrice.toFixed(2);
    }

    if(mobileBar){
      if(n>0){
        mobileBar.classList.add('active');
        document.body.classList.add('has-mobile-bar');
        if(mobileCount) mobileCount.textContent=n+' of '+max+' selected';
        if(n<max){
          if(mobileSub) mobileSub.textContent=(max-n)+' more to go';
          mobileCta.className='mobile-bar-cta disabled';
          mobileCta.textContent='Add '+(max-n)+' More';
        } else {
          if(mobileSub) mobileSub.textContent='$'+pack.salePrice.toFixed(2)+' \u00B7 Free shipping';
          mobileCta.className='mobile-bar-cta ready';
          mobileCta.textContent='Add to Cart';
        }
      } else {
        mobileBar.classList.remove('active');
        document.body.classList.remove('has-mobile-bar');
      }
    }
  }

  allCards.forEach(function(card){
    card.addEventListener('click',function(e){
      if(e.target.closest('.prod-qty')){
        var id=card.getAttribute('data-id');
        for(var i=selected.length-1;i>=0;i--){
          if(selected[i].id===id){selected.splice(i,1);break}
        }
        render();return;
      }
      if(e.target.closest('.prod-info')){return}
      var id=card.getAttribute('data-id');
      var max=PACKS[packSize].max;
      if(selected.length>=max)return;
      selected.push({id:id,name:card.getAttribute('data-name'),img:card.getAttribute('data-img'),price:parseInt(card.getAttribute('data-price')||'0',10)});
      render();
    });
  });

  if(sbClear) sbClear.addEventListener('click',function(){selected=[];try{localStorage.removeItem('lc_bundle_selections')}catch(e){}render()});

  function addToCart(){
    if(selected.length<PACKS[packSize].max)return;
    var items={};
    selected.forEach(function(s){items[s.id]=(items[s.id]||0)+1});
    var body={items:[]};
    Object.keys(items).forEach(function(id){body.items.push({id:parseInt(id,10),quantity:items[id]})});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
    .then(function(r){return r.json()})
    .then(function(){window.location.href='/cart'});
  }

  sbCta.addEventListener('click',function(e){e.preventDefault();addToCart()});
  if(mobileCta) mobileCta.addEventListener('click',function(e){e.preventDefault();addToCart()});

  /* 3D CTA wrap */
  function wrap3D(btn){
    if(btn.parentElement&&btn.parentElement.classList.contains('cta-3d-wrap'))return;
    var wrap=document.createElement('span');
    wrap.className='cta-3d-wrap';
    if(btn.classList.contains('prod-add')||btn.classList.contains('sb-cta')||btn.classList.contains('mobile-bar-cta'))wrap.classList.add('cta-3d-wrap--full');
    btn.parentNode.insertBefore(wrap,btn);
    wrap.appendChild(btn);
  }
  document.querySelectorAll('.prod-add').forEach(wrap3D);

  /* PRODUCT INFO DATA */
  var PROD_INFO_BY_NAME={
    'Beet + Fennel':{cat:'Sauerkraut',ingredients:['Organic Cabbage','Organic Beets','Organic Fennel','Sea Salt'],note:'All ingredients are certified organic. No vinegar, no sugar, no preservatives.',details:'A naturally fermented sauerkraut with deep earthy beet flavor and a gentle anise finish from fresh fennel.',uses:['Grain bowls','Roasted root vegetables','Sandwiches & wraps','Charcuterie boards','Avocado toast','Straight from the jar']},
    'Turmeric + Ginger + Jalapeno':{cat:'Sauerkraut',ingredients:['Organic Cabbage','Organic Turmeric','Organic Jalape\u00f1o','Sea Salt','Organic Ginger','Filtered Water'],note:'All ingredients are certified organic.',details:'One of the only turmeric krauts fermented with fresh turmeric root. Warming ginger and a slow jalape\u00f1o kick.',uses:['Tacos & burritos','Scrambled eggs','Warm soups & stews','Curry bowls','Brine shots','Stir-fry topper']},
    'Golden Beet + Dill':{cat:'Sauerkraut',ingredients:['Organic Cabbage','Organic Golden Beets','Sea Salt','Organic Garlic','Organic Dill'],note:'All ingredients are certified organic.',details:'Tangy, garlic dill kick that tastes like your favorite classic.',uses:['Smoked salmon','Deviled eggs','Avocado toast','Fish tacos','Potato salad']},
    'Garlic + Ginger Kimchi':{cat:'Kraut-chi',ingredients:['Organic Green Cabbage','Organic Green Onion','Organic Chili Paste','Sea Salt','Filtered Water','Organic Ginger','Organic Garlic'],note:'No fish sauce, no sugar.',details:'A vegan kimchi using German sauerkraut technique with Korean-inspired flavors.',uses:['Fried eggs','Rice bowls','Stir fry','Ramen','Grilled cheese','Straight from the jar']},
    'Carrot + Cilantro + Jalapeno':{cat:'Sauerkraut',ingredients:['Organic Cabbage','Organic Onion','Organic Carrots','Filtered Water','Organic Jalape\u00f1o','Sea Salt','Organic Garlic','Organic Cilantro'],note:'All ingredients are certified organic.',details:'Our version of a curtido. Bold, garlicky, built for tacos.',uses:['Tacos','Fish tacos','Burrito bowls','Nachos','Grilled chicken','Quesadillas']},
    'Juniper + Sage':{cat:'Sauerkraut',ingredients:['Organic Cabbage','Organic Apples','Sea Salt','Organic Sage','Organic Juniper Berries'],note:'All ingredients are certified organic.',details:'Juniper berries add a piney complexity while sage brings warmth and depth.',uses:['Roasted pork','Bratwurst','Charcuterie boards','Thanksgiving turkey','Wild game']},
    'Apple + Hops':{cat:'Sauerkraut',ingredients:['Organic Cabbage','Organic Apples','Filtered Water','Sea Salt','Organic Hops'],note:'All ingredients are certified organic.',details:'Crisp apple sweetness balanced by aromatic hops.',uses:['Bratwurst','Craft beer pairing','Pork tenderloin','Cheese plates','Turkey burgers']},
    'Chili Paste':{cat:'Sauce',ingredients:['Red Jalape\u00f1os (Organic)','Garlic (Organic)','Ginger (Organic)','Sea Salt'],note:'No vinegar, no sugar, no preservatives.',details:'A deeply fermented chili paste with layers of umami and slow-building heat.',uses:['Ramen','Pizza','Marinades','Stir-fry','Bloody Marys']},
    'Glow Sauce':{cat:'Sauce',ingredients:['Fermented Carrots (Organic)','Fermented Chili Paste (Organic)','Avocado Oil (Organic)','Sea Salt','Cumin Powder (Organic)'],note:'The golden glow comes from fermented carrots.',details:'The everything sauce. Lightly spicy, probiotic-rich.',uses:['Roasted cauliflower','Grain bowls','Salad dressing','Marinades','Tacos','Eggs']}
  };

  /* Badge map — matches mockup exactly */
  var BADGES={
    'beet + fennel':{text:'Bestseller',color:'var(--beet)'},
    'turmeric + ginger + jalapeno':{text:'Anti-Inflammatory',color:'var(--turmeric)'},
    'golden beet + dill':{text:'Refreshing',color:'var(--sage)'},
    'garlic + ginger kimchi':{text:'Fan Favorite',color:'var(--kimchi)'},
    'carrot + cilantro + jalapeno':{text:'Bright',color:'var(--gold)'},
    'juniper + sage':{text:'Herbaceous',color:'var(--sage)'},
    'apple + hops':{text:'Unique',color:'var(--amber)'},
    'chili paste':{text:'Heat',color:'var(--chili)'},
    'glow sauce':{text:'New',color:'var(--turmeric)'}
  };
  function findBadge(name){
    var key=name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    return BADGES[key];
  }

  /* Inject badges + ? buttons */
  allCards.forEach(function(card){
    var name=card.getAttribute('data-name');
    var media=card.querySelector('.prod-media');

    /* Badge */
    var badge=findBadge(name);
    if(badge&&media&&!media.querySelector('.prod-badge')){
      var span=document.createElement('span');
      span.className='prod-badge';
      span.style.color=badge.color;
      span.textContent=badge.text;
      media.insertBefore(span,media.firstChild);
    }

    /* ? info button */
    if(!PROD_INFO_BY_NAME[name])return;
    var nameEl=card.querySelector('.prod-name');
    if(!nameEl)return;
    var btn=document.createElement('span');
    btn.className='prod-info';
    btn.textContent='?';
    btn.setAttribute('data-info-name',name);
    btn.setAttribute('role','button');
    btn.setAttribute('aria-label','Product info');
    nameEl.appendChild(document.createTextNode(' '));
    nameEl.appendChild(btn);
  });

  /* MODAL LOGIC */
  var modalOverlay=document.getElementById('modalOverlay');
  var modal=document.getElementById('modal');
  var modalClose=document.getElementById('modalClose');
  var modalTitle=document.getElementById('modalTitle');
  var modalCat=document.getElementById('modalCat');
  var modalTabs=document.querySelectorAll('.modal-tab');
  var panelIngr=document.getElementById('panelIngredients');
  var panelDetails=document.getElementById('panelDetails');
  var panelUses=document.getElementById('panelUses');

  if(!modalOverlay) return render();

  function openModal(name){
    var info=PROD_INFO_BY_NAME[name];
    if(!info)return;
    modalTitle.textContent=name;
    modalCat.textContent=info.cat;
    modalCat.style.color=info.cat==='Sauce'?'var(--chili)':info.cat==='Kraut-chi'?'var(--kimchi)':'var(--beet)';
    clearNode(panelIngr);
    var pills=document.createElement('div');pills.className='ingr-pills';
    info.ingredients.forEach(function(ing){var pill=document.createElement('span');pill.className='ingr-pill';pill.textContent=ing;pills.appendChild(pill)});
    panelIngr.appendChild(pills);
    var note=document.createElement('p');note.className='modal-note';note.textContent=info.note;panelIngr.appendChild(note);
    clearNode(panelDetails);
    var dtxt=document.createElement('p');dtxt.className='modal-details-text';dtxt.textContent=info.details;panelDetails.appendChild(dtxt);
    clearNode(panelUses);
    var ul=document.createElement('ul');ul.className='modal-uses-list';
    info.uses.forEach(function(u){var li=document.createElement('li');li.textContent=u;ul.appendChild(li)});
    panelUses.appendChild(ul);
    modalTabs.forEach(function(t){t.classList.remove('active')});modalTabs[0].classList.add('active');
    panelIngr.classList.add('active');panelDetails.classList.remove('active');panelUses.classList.remove('active');
    modalOverlay.classList.add('open');document.body.style.overflow='hidden';
  }
  function closeModal(){modalOverlay.classList.remove('open');document.body.style.overflow=''}
  modalClose.addEventListener('click',closeModal);
  modalOverlay.addEventListener('click',function(e){if(e.target===modalOverlay)closeModal()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modalOverlay.classList.contains('open'))closeModal()});
  modalTabs.forEach(function(tab){tab.addEventListener('click',function(){
    modalTabs.forEach(function(t){t.classList.remove('active')});tab.classList.add('active');
    var which=tab.getAttribute('data-mtab');
    panelIngr.classList.toggle('active',which==='ingredients');
    panelDetails.classList.toggle('active',which==='details');
    panelUses.classList.toggle('active',which==='uses');
  })});
  document.addEventListener('click',function(e){
    var infoBtn=e.target.closest('.prod-info');
    if(infoBtn){e.stopPropagation();e.preventDefault();openModal(infoBtn.getAttribute('data-info-name'))}
  });

  /* REVIEWS */
  var REVIEWS=[
    {name:"Mary Keil",product:"Turmeric + Ginger + Jalape\u00f1o",text:"Your krauts are less expensive and most importantly memorably, mouthwateringly delicious! I love the lively flavors of both the turmeric ginger jalape\u00f1o and carrot cilantro jalape\u00f1o krauts.",date:""},
    {name:"Christina Truong",product:"Garlic + Ginger Kimchi",text:"Hello! I stumbled across your garlic + ginger kimchi at Sprouts the other month and have been absolutely obsessed with it.",date:""},
    {name:"Dr. Jeannie Smith",product:"Local Culture",text:"I am writing to not only praise you for your delicious local product, but I want you to know that your easy peel label is a game changer! Thank you so much! I will tell this to everyone I know and continue to purchase your products. Well done! Very well done indeed!",date:""},
    {name:"Wanda Wilson",product:"Golden Beet + Dill",text:"I'm in love! I bought golden beet and dill today. Finished a jar, all by myself, of beet and fennel\u2026 superb! Thank you for this product!!",date:""},
    {name:"Carmen Hightower",product:"Carrot + Cilantro + Jalape\u00f1o",text:"I absolutely love your products! The carrot, cilantro, and jalape\u00f1o sauerkraut is my absolute favorite.",date:""},
    {name:"Linda Cox",product:"Garlic + Ginger Kimchi",text:"OMG!! I just purchased a jar of this wonderful kimchi and this is exactly what I was looking for! The flavors are perfect together and it made my lunch so much more interesting and delicious. Keep up the good work!",date:""},
    {name:"Ted Bowes",product:"Garlic + Ginger Kimchi",text:"I have to tell you your products are fantastic. I have tried 4 of your sauerkraut products and your kimchi, and eat them right out of the jar. All I can say is WOW \u2014 you aced it.",date:""},
    {name:"Sarah Kramer",product:"Garlic + Ginger Kimchi",text:"I love this kimchi so much, it's the best I've ever had anywhere ever!! Thank you.",date:""},
    {name:"Kelly Valentine",product:"Garlic + Ginger Kimchi",text:"I absolutely love your sauerkraut and kimchi! I have tried every probiotic and this is hands-down the best!",date:""},
    {name:"Thomas Washington",product:"Garlic + Ginger Kimchi",text:"Had to tell you how much I love the Ginger Garlic Kimchi. You give nourishing new meaning. Thank you for a terrific product.",date:""},
    {name:"Cynthia Nielsen",product:"Garlic + Ginger Kimchi",text:"I just finished my first jar of the garlic and ginger sauerkraut and it was amazing. I love that it's in glass. So thrilled with the easy peel label\u2026 genius! Love your product!",date:""},
    {name:"Chinwe Appio",product:"Garlic + Ginger Kimchi",text:"First, I wanted to thank you for bringing your products to the market. I am healing and need to incorporate more fermented foods into my diet. I tried your garlic and ginger flavour last week and I am hooked.",date:""},
    {name:"Paul Benjamin",product:"Juniper + Sage",text:"What an amazing nutritional and energetic product benefiting one's digestion and well being! I'm a big fan of your juniper + sage, and the habanero, ginger and turmeric varieties. Great choices on your blends!! Your prices beat all your competitors. Thank you for the love, time and dedication to your ingredients \u2014 resulting in superlative sauerkraut.",date:""},
    {name:"Lou Preston",product:"Turmeric + Ginger + Jalape\u00f1o",text:"Ginger, Turmeric and Jalape\u00f1o. Fabulous. I make kraut also from cabbage we grow on our organic farm. I know good when I taste it and yours is that.",date:""},
    {name:"Phebe Rosenthal",product:"Turmeric + Ginger + Jalape\u00f1o",text:"I eat kraut daily and I just tried your Turmeric and it's THE BEST!",date:""},
    {name:"Timothy Randall",product:"Local Culture",text:"Let me just start off by saying I absolutely love y'all's sauerkraut. I'd normally consider myself a frugal person \u2014 I'm attending university and don't have a lot of extra money \u2014 so I'd buy generic sauerkraut. However, once I tasted Local Culture, I was convinced that splurging a little here and there was a necessity!",date:""},
    {name:"Josh Golder",product:"Golden Beet + Dill",text:"I have Crohn's disease and absolutely love your golden dill sauerkraut \u2014 it's great for gut health and digestion. Thanks!",date:""},
    {name:"Faye Marshall",product:"Garlic + Ginger Kimchi",text:"I'm in love with this kimchi.",date:""},
    {name:"Kathleen Nichols",product:"Garlic + Ginger Kimchi",text:"Hi up there\u2026 we L O V E your garlic + ginger Kimchi.",date:""},
    {name:"Vicki Plummer",product:"Golden Beet + Dill",text:"Hi, I love your products, thank you!",date:""},
    {name:"Lianne Wood",product:"Local Culture",text:"I just want to say how much I enjoy your sauerkraut. I love the fact that you use glass and your labels are easy to remove so the jar may be reused easily for other things.",date:""},
    {name:"Ashley Hernandez",product:"Local Culture",text:"I just wanted to let you know how much I really enjoy your products. I love your fermented foods \u2014 they've been a staple in my house for years.",date:""},
    {name:"Janet Arnold",product:"Local Culture",text:"I have tried every brand in all the local markets and Whole Foods and your products truly outshine anything I can find here.",date:""},
    {name:"Laurent-Paul Durell",product:"Local Culture",text:"The combination of ingredients was thought out and balanced, not too salty. I like the way the cabbage was shredded to the right size. I have purchased other brands but yours is definitively at the top. Thank you for making a delicious and healthy product.",date:""},
    {name:"Robert Keith",product:"Local Culture",text:"Love your products \u2014 I try to consume at least one jar per month.",date:""},
    {name:"Kathy Rock",product:"Local Culture",text:"Wanted to let you know how much I enjoy your products! They are the best!!!! I am addicted \u2014 yours are special.",date:""},
    {name:"Jennifer",product:"Variety Bundle",text:"Shipping was quick and just as described, lots of communication, products arrived perfectly. Loved trying the flavors I had been wanting to try for so long! Will definitely order again! Thank you so much!!",date:""}
  ];
  var reviewsGrid=document.getElementById('reviewsGrid');
  var loadMoreBtn=document.getElementById('loadMoreBtn');
  if(reviewsGrid){
    REVIEWS.forEach(function(r,i){
      var card=document.createElement('div');card.className='review-card';
      var header=document.createElement('div');header.className='review-header';
      var left=document.createElement('div');
      var nameSpan=document.createElement('span');nameSpan.className='review-author';nameSpan.textContent=r.name;
      var verSpan=document.createElement('span');verSpan.className='review-verified';verSpan.textContent='Verified Buyer';
      left.appendChild(nameSpan);left.appendChild(verSpan);
      var dateSpan=document.createElement('span');dateSpan.className='review-date';dateSpan.textContent=r.date;
      header.appendChild(left);header.appendChild(dateSpan);
      var stars=document.createElement('span');stars.className='review-stars';stars.textContent='\u2605\u2605\u2605\u2605\u2605';
      var prod=document.createElement('p');prod.className='review-product';prod.textContent=r.product;
      var text=document.createElement('p');text.className='review-text';text.textContent=r.text;
      card.appendChild(header);card.appendChild(stars);card.appendChild(prod);card.appendChild(text);
      reviewsGrid.appendChild(card);
    });
  }
  if(loadMoreBtn) loadMoreBtn.addEventListener('click',function(){
    document.querySelectorAll('.review-card.hidden').forEach(function(c){c.classList.remove('hidden')});
    loadMoreBtn.classList.add('hide');
  });

  /* Load existing cart items into bundle builder on page load.
     Uses localStorage so cart items are NOT removed — safe if user navigates away. */
  function loadCartIntoBundle(){
    /* First check localStorage for saved bundle selections */
    try {
      var saved=JSON.parse(localStorage.getItem('lc_bundle_selections')||'null');
      if(saved&&saved.length){
        var cardMap={};
        allCards.forEach(function(card){cardMap[card.getAttribute('data-id')]=card});
        var max=PACKS[packSize].max;
        saved.forEach(function(s){
          if(selected.length>=max)return;
          if(cardMap[s.id]){selected.push(s)}
        });
        render();return;
      }
    }catch(e){}

    /* If no localStorage, check cart for items matching bundle products */
    fetch('/cart.js',{method:'GET',headers:{'Content-Type':'application/json'}})
    .then(function(r){return r.json()})
    .then(function(cart){
      if(!cart||!cart.items||!cart.items.length){render();return}
      var cardMap={};
      allCards.forEach(function(card){cardMap[card.getAttribute('data-id')]=card});
      var max=PACKS[packSize].max;
      cart.items.forEach(function(item){
        var vid=String(item.variant_id);
        var card=cardMap[vid];
        if(!card)return;
        for(var q=0;q<item.quantity&&selected.length<max;q++){
          selected.push({
            id:vid,
            name:card.getAttribute('data-name'),
            img:card.getAttribute('data-img'),
            price:parseInt(card.getAttribute('data-price')||'0',10)
          });
        }
      });
      saveBundleToStorage();
      render();
    })
    .catch(function(){render()});
  }

  /* Persist bundle selections to localStorage */
  function saveBundleToStorage(){
    try{localStorage.setItem('lc_bundle_selections',JSON.stringify(selected))}catch(e){}
  }

  /* Patch render to save on every change */
  var _origRender=render;
  render=function(){_origRender();saveBundleToStorage()};

  /* Clear localStorage when bundle is added to cart */
  var _origAddToCart=addToCart;
  addToCart=function(){
    try{localStorage.removeItem('lc_bundle_selections')}catch(e){}
    _origAddToCart();
  };
  loadCartIntoBundle();
})();
